<template>
	<div
		class="event-list-item-volley"
		:class="[`-repeat-${numberOfPeriods}`]"
	>
		<div class="event-list-item-volley__logo event-list-item-volley__cell">
			<img
				:src="$Helpers.getScaledImageUrl(homeImgUrl, 50)"
				:alt="homeName"
			>
		</div>
		<div class="event-list-item-volley__name event-list-item-volley__cell u-show-as-flex@sm">
			{{ homeNameFull }}
		</div>
		<div class="event-list-item-volley__name event-list-item-volley__cell u-hide@sm">
			{{ homeName }}
		</div>
		<div class="event-list-item-volley__score event-list-item-volley__cell">
			{{ noSpoilerMode ? '-' : homeScoreWithFallback }}
		</div>
		<div
			v-for="(period, i) in scores"
			:key="`setshome-${period.id}`"
			class="event-list-item-volley__set event-list-item-volley__cell"
			:class="{
				'-loser': ((period.teamHomeScoreInPeriod < period.teamGuestScoreInPeriod) && (i < numberOfPeriods - 1 || status !== EVENT_STATUS.LIVE)),
			}"
		>
			{{ noSpoilerMode ? '-' : (period.teamHomeScoreInPeriod || '0') }}
		</div>
		<div class="event-list-item-volley__logo event-list-item-volley__cell">
			<img
				:src="$Helpers.getScaledImageUrl(guestImgUrl, 50)"
				:alt="guestName"
			>
		</div>
		<div class="event-list-item-volley__name event-list-item-volley__cell u-show-as-flex@sm">
			{{ guestNameFull }}
		</div>
		<div class="event-list-item-volley__name event-list-item-volley__cell u-hide@sm">
			{{ guestName }}
		</div>
		<div class="event-list-item-volley__score event-list-item-volley__cell">
			{{ noSpoilerMode ? '-' : guestScoreWithFallback }}
		</div>
		<div
			v-for="(period, i) in scores"
			:key="`setsguest-${period.id}`"
			class="event-list-item-volley__set event-list-item-volley__cell"
			:class="{ '-loser': ((period.teamHomeScoreInPeriod > period.teamGuestScoreInPeriod) && (i < numberOfPeriods - 1 || status !== EVENT_STATUS.LIVE)) }"
		>
			{{ noSpoilerMode ? '-' : (period.teamGuestScoreInPeriod || '0') }}
		</div>
	</div>
</template>

<script>
import { EVENT_STATUS } from '@shared/utils/eventUtils';

export default {
	name:  'EventListItemVolleyContent',
	props: {
		homeName: {
			type:    String,
			default: null,
		},
		homeNameFull: {
			type:    String,
			default: null,
		},
		homeImgUrl: {
			type:    String,
			default: null,
		},
		homeScoreWithFallback: {
			type:    String,
			default: '',
		},
		guestName: {
			type:    String,
			default: null,
		},
		guestNameFull: {
			type:    String,
			default: null,
		},
		guestImgUrl: {
			type:    String,
			default: null,
		},
		guestScoreWithFallback: {
			type:    String,
			default: '',
		},
		numberOfPeriods: {
			type:    Number,
			default: 0,
		},
		scores: {
			type:    Array,
			default: () => [],
		},
		noSpoilerMode: {
			type:    Boolean,
			default: false,
		},
		status: {
			type:     String,
			required: true,
		},
	},
	data() {
		return {
			EVENT_STATUS,
		};
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.event-list-item-volley {
	--width-logo: 32px;
	--width-name: 54px;
	--width-main-result: 36px;
	--width-set-result: 28px;
	display: grid;
	max-width: 100%;
	gap: $sp3 0;
	overflow-x: auto;

	&.-repeat-0 {
		grid-template-columns: var(--width-logo) var(--width-name) var(--width-main-result);
	}

	&.-repeat-1 {
		grid-template-columns: var(--width-logo) var(--width-name) var(--width-main-result) var(--width-set-result);
	}

	&.-repeat-2 {
		grid-template-columns: var(--width-logo) var(--width-name) var(--width-main-result) repeat(2, var(--width-set-result));
	}

	&.-repeat-3 {
		grid-template-columns: var(--width-logo) var(--width-name) var(--width-main-result) repeat(3, var(--width-set-result));
	}

	&.-repeat-4 {
		grid-template-columns: var(--width-logo) var(--width-name) var(--width-main-result) repeat(4, var(--width-set-result));
	}

	&.-repeat-5 {
		grid-template-columns: var(--width-logo) var(--width-name) var(--width-main-result) repeat(5, var(--width-set-result));
	}

	@include size(sm-up) {
		--width-logo: 32px;
		--width-name: 230px;
		--width-main-result: 45px;
		--width-set-result: 35px;
	}

	@include size(md-up) {
		--width-logo: 42px;
		--width-name: 270px;
		--width-main-result: 45px;
		--width-set-result: 35px;
	}
}

.event-list-item-volley__cell {
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 2ch;
	min-height: 2.5ex;
}

.event-list-item-volley__name {
	@include font-size(fs-80);
	margin-right: $sp3;
	flex-grow: 0;
	justify-content: flex-start;
}

.event-list-item-volley__logo {
	width: $sp5;

	@include size(md-up) {
		width: $sp6;
	}
}

.event-list-item-volley__score {
	@include font(primary, bold, normal, fs-150);

	@include size(sm-up) {
		@include font(primary, medium, normal, fs-150);
	}
}

.event-list-item-volley__set {
	@include font(primary, book, normal, fs-100);

	&.-loser {
		color: var(--color-grey-300);
	}

	@include size(md-up) {
		@include font-size(fs-80);
	}
}

.event-list-item-volley__score + .event-list-item-volley__set {
	margin-left: $sp2;

	@include size(sm-up) {
		margin-left: $sp3;
	}
}
</style>
